import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    permissions: [],
    roles: []
  }),

  getters: {
    hasPermission: (state) => (permission) => {
      return state.permissions.includes(permission);
    },
    hasAnyPermission: (state) => (permissions) => {
      return permissions.some(p => state.permissions.includes(p));
    },
    hasAllPermissions: (state) => (permissions) => {
      return permissions.every(p => state.permissions.includes(p));
    },
    hasRole: (state) => (role) => {
      return state.roles.includes(role);
    },
    hasAnyRole: (state) => (roles) => {
      return roles.some(r => state.roles.includes(r));
    },
    hasAllRoles: (state) => (roles) => {
      return roles.every(r => state.roles.includes(r));
    }
  },

  actions: {
    setPermissions(permissions) {
      this.permissions = permissions || [];
    },
    clearPermissions() {
      this.permissions = [];
    },
    setRoles(roles) {
      this.roles = roles || [];
    },
    clearRoles() {
      this.roles = [];
    },
    reset() {
      this.$reset();
    }
  }
});